import React from 'react';

export default function Hammer() {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38">
      <path d="M37,16.68l-2-1.91a2.7,2.7,0,0,1-3.88,0,2.67,2.67,0,0,1,0-3.87L27.29,7C22.06,1.85,15.57-.68,10.22.16a1.2,1.2,0,0,0-.61.19A1.53,1.53,0,0,0,9,1.52V1.8a1.53,1.53,0,0,0,.94,1.38A20.24,20.24,0,0,1,16.6,8c2.71,2.79,3.19,6.57,1,8.83L7.63,26.62,4.94,23.79a3,3,0,0,0-4.05,0,2.47,2.47,0,0,0,0,3.77l9.59,9.65a2.81,2.81,0,0,0,1.93.78,2.56,2.56,0,0,0,2-.93,2.74,2.74,0,0,0-.28-3.68l-2.61-3L24.76,17.63c1.11-1.1-.23,1.9.88,3a2.63,2.63,0,0,1,0,3.87l2,1.93a2.7,2.7,0,0,0,3.88,0l5.83-5.78a2.87,2.87,0,0,0-.26-4Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/Hammer/index.js